import { type SxProps } from "@mui/material";
import { keyframes, styled, type CSSObject, type Theme } from "@mui/material/styles";

import { type LoadingButtonIconPhase } from "ui/button/loading-button/loading-button.types";

import Icons from "assets";

/** No `transitions.duration` step covers a rotation period — MUI's scale stops at 375ms. */
const SPIN_PERIOD = "1s";

const spin = keyframes({ to: { transform: "rotate(360deg)" } });

const ICON_PHASE_STYLE: Record<LoadingButtonIconPhase, CSSObject> = {
  hidden: { opacity: 0, transform: "rotate(-180deg)" },
  rotating: {},
  scaling: { transform: "scale(1.25)" },
  visible: {},
};

export const LOADING_BUTTON_SX: SxProps<Theme> = (theme) => ({
  transition: theme.transitions.create("all", { duration: theme.transitions.duration.shortest }),
});

/**
 * `shortest` against the `shorter` of `TRANSITION_DURATION`, the timer that swaps the label: the fade
 * finishes first, so the swap always lands on content that is already invisible.
 */
export const LoadingButtonFade = styled("span", {
  shouldForwardProp: (prop) => prop !== "isFaded",
})<{ isFaded: boolean }>(({ theme, isFaded }) => ({
  display: "flex",
  opacity: isFaded ? 0 : 1,
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const LoadingButtonIconFrame = styled("span", {
  shouldForwardProp: (prop) => prop !== "iconPhase",
})<{ iconPhase?: LoadingButtonIconPhase }>(({ theme, iconPhase = "visible" }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: theme.transitions.create("all", {
    duration: theme.transitions.duration.standard,
    easing: theme.transitions.easing.easeOut,
  }),
  ...ICON_PHASE_STYLE[iconPhase],
}));

export const LoadingButtonSpinner = styled(Icons.Spinner)({
  animation: `${spin} ${SPIN_PERIOD} linear infinite`,
});
